import { differenceInDays } from "date-fns";

// export const calculateDaysAgo = (dateString) => {
//   const today = new Date();
//   const [day, month, year] = dateString.split("/").map(Number);
//   const targetDate = new Date(year, month - 1, day); // Month is 0-based
//   return differenceInDays(today, targetDate);
// };

export const calculateDaysAgo = (dateString) => {
  // Expecting DD/MM/YYYY
  const [day, month, year] = dateString.split("/").map(Number);

  // Create Date object safely
  const givenDate = new Date(year, month - 1, day);
  const today = new Date();

  // Reset times to midnight for accurate day diff
  givenDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  // Calculate time difference in milliseconds
  const diffTime = today - givenDate;

  // Convert to days, months, and years
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  // Return formatted string
  if (diffYears > 0) return diffYears === 1 ? "1 year" : `${diffYears} years`;
  if (diffMonths > 0)
    return diffMonths === 1 ? "1 month" : `${diffMonths} months`;
  return diffDays === 1 ? "1 day" : `${diffDays} days`;
};

// Example usage:
console.log(calculateDaysAgo("21/08/2025"));

export const formatToIndianUnits = (amount) => {
  if (Math.abs(amount) >= 10000000) {
    return (amount / 10000000).toFixed(1).replace(/\.0$/, "") + "C"; // Crore
  } else if (Math.abs(amount) >= 100000) {
    return (amount / 100000).toFixed(1).replace(/\.0$/, "") + "L"; // Lakh
  } else if (Math.abs(amount) >= 1000) {
    return (amount / 1000).toFixed(1).replace(/\.0$/, "") + "K"; // Thousand
  }
  return amount.toLocaleString("en-IN"); // Default Indian numbering format
};

export const IndianCurrencyDisplay = ({ amount, isPositive }) => {
  return (
    <span
      style={{
        color: isPositive ? "#2C3659" : "#ff0000",
      }}
    >
      {formatToIndianUnits(amount)}
    </span>
  );
};

export const compareSale = (data, target) => {
  const salePrevious = data[0]?.[target] || 0;
  const saleCurrent = data[1]?.[target] || 0;
  console.log("COM55", data, salePrevious, saleCurrent);

  if (salePrevious === 0) return "No previous sales data"; // Avoid division by zero

  const percentage = ((saleCurrent - salePrevious) / salePrevious) * 100;
  const retVal = {
    value: Math.abs(percentage).toFixed(0),
    increase: percentage > 0,
  };
  return retVal;
};

export const calculateProfitAmount = (data) => {
  const totalSales = data[0]?.totalSales || 0;
  const totalExpenses = data[0]?.totalExpense || 0;
  const difference = totalSales - totalExpenses;
  const retVal = {
    value: Math.abs(difference).toFixed(0),
    increase: difference > 0,
  };
  return retVal;
};

export const compareProfitByAmount = (data) => {
  const previous = data[0]?.totalSales - data[0]?.totalExpense;
  const current = data[1]?.totalSales - data[1]?.totalExpense;

  if (previous === 0) return "No previous sales data"; // Avoid division by zero

  const percentage = ((current - previous) / previous) * 100;
  const retVal = {
    value: Math.abs(percentage).toFixed(0),
    increase: percentage > 0,
  };
  return retVal;
};

export const propertyUnits = () => {
  const data = {
    areaUnits: [
      // {
      //   name: "METER",
      //   value: "meter",
      // },
      // {
      //   name: "YARD",
      //   value: "yard",
      // },
      // {
      //   name: "FEET",
      //   value: "ft",
      // },
      {
        name: "Meter",
        value: "Meter",
      },
      {
        name: "Yard",
        value: "Yard",
      },
      {
        name: "Feet",
        value: "Feet",
      },
    ],
    priceUnits: [
      {
        name: "Thousand(s)",
        value: "TH",
      },
      {
        name: "Lakh(s)",
        value: "LKH",
      },
      {
        name: "Crore(s)",
        value: "CR",
      },
    ],
    // bhkTypes: [...Array.from({ length: 10 }, (_, i) => (i + 1).toString())],
    bhkTypes: [
      "0",
      "1",
      "1RK",
      "2",
      "2RK",
      ...Array.from({ length: 33 }, (_, i) => (i + 3).toString()),
    ],
    floors: [
      ...Array.from({ length: 60 }, (_, i) => i.toString()),
      "GF",
      "Terrace",
      "4th",
      "4th+Terrace",
      "TF",
      "TF+Terrace",
      "TF+4th",
      "TF+4th+Terrace",
      "SF",
      "SF+Terrace",
      "SF+4th",
      "SF+4th+Terrace",
      "SF+TF",
      "SF+TF+Terrace",
      "SF+TF+4th",
      "SF+TF+4th+Terrace",
      "FF",
      "FF+Terrace",
      "FF+4th",
      "FF+4th+Terrace",
      "FF+TF",
      "FF+TF+Terrace",
      "FF+TF+4th",
      "FF+TF+4th+Terrace",
      "FF+SF",
      "FF+SF+Terrace",
      "FF+SF+4th",
      "FF+SF+4th+Terrace",
      "FF+SF+TF",
      "FF+SF+TF+Terrace",
      "FF+SF+TF+4th",
      "FF+SF+TF+4th+Terrace",
      "UGF",
      "UGF+Terrace",
      "UGF+4th",
      "UGF+4th+Terrace",
      "UGF+TF",
      "UGF+TF+Terrace",
      "UGF+TF+4th",
      "UGF+TF+4th+Terrace",
      "UGF+SF",
      "UGF+SF+Terrace",
      "UGF+SF+4th",
      "UGF+SF+4th+Terrace",
      "UGF+SF+TF",
      "UGF+SF+TF+Terrace",
      "UGF+SF+TF+4th",
      "UGF+SF+TF+4th+Terrace",
      "UGF+FF",
      "UGF+FF+Terrace",
      "UGF+FF+4th",
      "UGF+FF+4th+Terrace",
      "UGF+FF+TF",
      "UGF+FF+TF+Terrace",
      "UGF+FF+TF+4th",
      "UGF+FF+TF+4th+Terrace",
      "UGF+FF+SF",
      "UGF+FF+SF+Terrace",
      "UGF+FF+SF+4th",
      "UGF+FF+SF+4th+Terrace",
      "UGF+FF+SF+TF",
      "UGF+FF+SF+TF+Terrace",
      "UGF+FF+SF+TF+4th",
      "UGF+FF+SF+TF+4th+Terrace",
      "BMT",
      "BMT+Terrace",
      "BMT+4th",
      "BMT+4th+Terrace",
      "BMT+TF",
      "BMT+TF+Terrace",
      "BMT+TF+4th",
      "BMT+TF+4th+Terrace",
      "BMT+SF",
      "BMT+SF+Terrace",
      "BMT+SF+4th",
      "BMT+SF+4th+Terrace",
      "BMT+SF+TF",
      "BMT+SF+TF+Terrace",
      "BMT+SF+TF+4th",
      "BMT+SF+TF+4th+Terrace",
      "BMT+FF",
      "BMT+FF+Terrace",
      "BMT+FF+4th",
      "BMT+FF+4th+Terrace",
      "BMT+FF+TF",
      "BMT+FF+TF+Terrace",
      "BMT+FF+TF+4th",
      "BMT+FF+TF+4th+Terrace",
      "BMT+FF+SF",
      "BMT+FF+SF+Terrace",
      "BMT+FF+SF+4th",
      "BMT+FF+SF+4th+Terrace",
      "BMT+FF+SF+TF",
      "BMT+FF+SF+TF+Terrace",
      "BMT+FF+SF+TF+4th",
      "BMT+FF+SF+TF+4th+Terrace",
      "BMT+UGF",
      "BMT+UGF+Terrace",
      "BMT+UGF+4th",
      "BMT+UGF+4th+Terrace",
      "BMT+UGF+TF",
      "BMT+UGF+TF+Terrace",
      "BMT+UGF+TF+4th",
      "BMT+UGF+TF+4th+Terrace",
      "BMT+UGF+SF",
      "BMT+UGF+SF+Terrace",
      "BMT+UGF+SF+4th",
      "BMT+UGF+SF+4th+Terrace",
      "BMT+UGF+SF+TF",
      "BMT+UGF+SF+TF+Terrace",
      "BMT+UGF+SF+TF+4th",
      "BMT+UGF+SF+TF+4th+Terrace",
      "BMT+UGF+FF",
      "BMT+UGF+FF+Terrace",
      "BMT+UGF+FF+4th",
      "BMT+UGF+FF+4th+Terrace",
      "BMT+UGF+FF+TF",
      "BMT+UGF+FF+TF+Terrace",
      "BMT+UGF+FF+TF+4th",
      "BMT+UGF+FF+TF+4th+Terrace",
      "BMT+UGF+FF+SF",
      "BMT+UGF+FF+SF+Terrace",
      "BMT+UGF+FF+SF+4th",
      "BMT+UGF+FF+SF+4th+Terrace",
      "BMT+UGF+FF+SF+TF",
      "BMT+UGF+FF+SF+TF+Terrace",
      "BMT+UGF+FF+SF+TF+4th",
      "BMT+UGF+FF+SF+TF+4th+Terrace",
      "Stilt",
      "Stilt+Terrace",
      "Stilt+4th",
      "Stilt+4th+Terrace",
      "Stilt+TF",
      "Stilt+TF+Terrace",
      "Stilt+TF+4th",
      "Stilt+TF+4th+Terrace",
      "Stilt+SF",
      "Stilt+SF+Terrace",
      "Stilt+SF+4th",
      "Stilt+SF+4th+Terrace",
      "Stilt+SF+TF",
      "Stilt+SF+TF+Terrace",
      "Stilt+SF+TF+4th",
      "Stilt+SF+TF+4th+Terrace",
      "Stilt+FF",
      "Stilt+FF+Terrace",
      "Stilt+FF+4th",
      "Stilt+FF+4th+Terrace",
      "Stilt+FF+TF",
      "Stilt+FF+TF+Terrace",
      "Stilt+FF+TF+4th",
      "Stilt+FF+TF+4th+Terrace",
      "Stilt+FF+SF",
      "Stilt+FF+SF+Terrace",
      "Stilt+FF+SF+4th",
      "Stilt+FF+SF+4th+Terrace",
      "Stilt+FF+SF+TF",
      "Stilt+FF+SF+TF+Terrace",
      "Stilt+FF+SF+TF+4th",
      "Stilt+FF+SF+TF+4th+Terrace",
      "Stilt+UGF",
      "Stilt+UGF+Terrace",
      "Stilt+UGF+4th",
      "Stilt+UGF+4th+Terrace",
      "Stilt+UGF+TF",
      "Stilt+UGF+TF+Terrace",
      "Stilt+UGF+TF+4th",
      "Stilt+UGF+TF+4th+Terrace",
      "Stilt+UGF+SF",
      "Stilt+UGF+SF+Terrace",
      "Stilt+UGF+SF+4th",
      "Stilt+UGF+SF+4th+Terrace",
      "Stilt+UGF+SF+TF",
      "Stilt+UGF+SF+TF+Terrace",
      "Stilt+UGF+SF+TF+4th",
      "Stilt+UGF+SF+TF+4th+Terrace",
      "Stilt+UGF+FF",
      "Stilt+UGF+FF+Terrace",
      "Stilt+UGF+FF+4th",
      "Stilt+UGF+FF+4th+Terrace",
      "Stilt+UGF+FF+TF",
      "Stilt+UGF+FF+TF+Terrace",
      "Stilt+UGF+FF+TF+4th",
      "Stilt+UGF+FF+TF+4th+Terrace",
      "Stilt+UGF+FF+SF",
      "Stilt+UGF+FF+SF+Terrace",
      "Stilt+UGF+FF+SF+4th",
      "Stilt+UGF+FF+SF+4th+Terrace",
      "Stilt+UGF+FF+SF+TF",
      "Stilt+UGF+FF+SF+TF+Terrace",
      "Stilt+UGF+FF+SF+TF+4th",
      "Stilt+UGF+FF+SF+TF+4th+Terrace",
      "Stilt+BMT",
      "Stilt+BMT+Terrace",
      "Stilt+BMT+4th",
      "Stilt+BMT+4th+Terrace",
      "Stilt+BMT+TF",
      "Stilt+BMT+TF+Terrace",
      "Stilt+BMT+TF+4th",
      "Stilt+BMT+TF+4th+Terrace",
      "Stilt+BMT+SF",
      "Stilt+BMT+SF+Terrace",
      "Stilt+BMT+SF+4th",
      "Stilt+BMT+SF+4th+Terrace",
      "Stilt+BMT+SF+TF",
      "Stilt+BMT+SF+TF+Terrace",
      "Stilt+BMT+SF+TF+4th",
      "Stilt+BMT+SF+TF+4th+Terrace",
      "Stilt+BMT+FF",
      "Stilt+BMT+FF+Terrace",
      "Stilt+BMT+FF+4th",
      "Stilt+BMT+FF+4th+Terrace",
      "Stilt+BMT+FF+TF",
      "Stilt+BMT+FF+TF+Terrace",
      "Stilt+BMT+FF+TF+4th",
      "Stilt+BMT+FF+TF+4th+Terrace",
      "Stilt+BMT+FF+SF",
      "Stilt+BMT+FF+SF+Terrace",
      "Stilt+BMT+FF+SF+4th",
      "Stilt+BMT+FF+SF+4th+Terrace",
      "Stilt+BMT+FF+SF+TF",
      "Stilt+BMT+FF+SF+TF+Terrace",
      "Stilt+BMT+FF+SF+TF+4th",
      "Stilt+BMT+FF+SF+TF+4th+Terrace",
      "Stilt+BMT+UGF",
      "Stilt+BMT+UGF+Terrace",
      "Stilt+BMT+UGF+4th",
      "Stilt+BMT+UGF+4th+Terrace",
      "Stilt+BMT+UGF+TF",
      "Stilt+BMT+UGF+TF+Terrace",
      "Stilt+BMT+UGF+TF+4th",
      "Stilt+BMT+UGF+TF+4th+Terrace",
      "Stilt+BMT+UGF+SF",
      "Stilt+BMT+UGF+SF+Terrace",
      "Stilt+BMT+UGF+SF+4th",
      "Stilt+BMT+UGF+SF+4th+Terrace",
      "Stilt+BMT+UGF+SF+TF",
      "Stilt+BMT+UGF+SF+TF+Terrace",
      "Stilt+BMT+UGF+SF+TF+4th",
      "Stilt+BMT+UGF+SF+TF+4th+Terrace",
      "Stilt+BMT+UGF+FF",
      "Stilt+BMT+UGF+FF+Terrace",
      "Stilt+BMT+UGF+FF+4th",
      "Stilt+BMT+UGF+FF+4th+Terrace",
      "Stilt+BMT+UGF+FF+TF",
      "Stilt+BMT+UGF+FF+TF+Terrace",
      "Stilt+BMT+UGF+FF+TF+4th",
      "Stilt+BMT+UGF+FF+TF+4th+Terrace",
      "Stilt+BMT+UGF+FF+SF",
      "Stilt+BMT+UGF+FF+SF+Terrace",
      "Stilt+BMT+UGF+FF+SF+4th",
      "Stilt+BMT+UGF+FF+SF+4th+Terrace",
      "Stilt+BMT+UGF+FF+SF+TF",
      "Stilt+BMT+UGF+FF+SF+TF+Terrace",
      "Stilt+BMT+UGF+FF+SF+TF+4th",
      "Stilt+BMT+UGF+FF+SF+TF+4th+Terrace",
      "GF",
      "GF+Terrace",
      "GF+4th",
      "GF+4th+Terrace",
      "GF+TF",
      "GF+TF+Terrace",
      "GF+TF+4th",
      "GF+TF+4th+Terrace",
      "GF+SF",
      "GF+SF+Terrace",
      "GF+SF+4th",
      "GF+SF+4th+Terrace",
      "GF+SF+TF",
      "GF+SF+TF+Terrace",
      "GF+SF+TF+4th",
      "GF+SF+TF+4th+Terrace",
      "GF+FF",
      "GF+FF+Terrace",
      "GF+FF+4th",
      "GF+FF+4th+Terrace",
      "GF+FF+TF",
      "GF+FF+TF+Terrace",
      "GF+FF+TF+4th",
      "GF+FF+TF+4th+Terrace",
      "GF+FF+SF",
      "GF+FF+SF+Terrace",
      "GF+FF+SF+4th",
      "GF+FF+SF+4th+Terrace",
      "GF+FF+SF+TF",
      "GF+FF+SF+TF+Terrace",
      "GF+FF+SF+TF+4th",
      "GF+FF+SF+TF+4th+Terrace",
      "GF+BMT",
      "GF+BMT+Terrace",
      "GF+BMT+4th",
      "GF+BMT+4th+Terrace",
      "GF+BMT+TF",
      "GF+BMT+TF+Terrace",
      "GF+BMT+TF+4th",
      "GF+BMT+TF+4th+Terrace",
      "GF+BMT+SF",
      "GF+BMT+SF+Terrace",
      "GF+BMT+SF+4th",
      "GF+BMT+SF+4th+Terrace",
      "GF+BMT+SF+TF",
      "GF+BMT+SF+TF+Terrace",
      "GF+BMT+SF+TF+4th",
      "GF+BMT+SF+TF+4th+Terrace",
      "GF+BMT+FF",
      "GF+BMT+FF+Terrace",
      "GF+BMT+FF+4th",
      "GF+BMT+FF+4th+Terrace",
      "GF+BMT+FF+TF",
      "GF+BMT+FF+TF+Terrace",
      "GF+BMT+FF+TF+4th",
      "GF+BMT+FF+TF+4th+Terrace",
      "GF+BMT+FF+SF",
      "GF+BMT+FF+SF+Terrace",
      "GF+BMT+FF+SF+4th",
      "GF+BMT+FF+SF+4th+Terrace",
      "GF+BMT+FF+SF+TF",
      "GF+BMT+FF+SF+TF+Terrace",
      "GF+BMT+FF+SF+TF+4th",
      "GF+BMT+FF+SF+TF+4th+Terrace",
      // "4th",
      // "4th+Terrace",
      // "TF",
      // "TF+Terrace",
      // "TF+4th",
      // "TF+4th+Terrace",
      // "SF",
      // "SF+Terrace",
      // "SF+4th",
      // "SF+4th+Terrace",
      // "SF+TF",
      // "SF+TF+Terrace",
      // "SF+TF+4th",
      // "SF+TF+4th+Terrace",
      // "FF",
      // "FF+Terrace",
      // "FF+4th",
      // "FF+4th+Terrace",
      // "FF+TF",
      // "FF+TF+Terrace",
      // "FF+TF+4th",
      // "FF+TF+4th+Terrace",
      // "FF+SF",
      // "FF+SF+Terrace",
      // "FF+SF+4th",
      // "FF+SF+4th+Terrace",
      // "FF+SF+TF",
      // "FF+SF+TF+Terrace",
      // "FF+SF+TF+4th",
      // "FF+SF+TF+4th+Terrace",
      // "UGF",
      // "UGF+Terrace",
      // "UGF+4th",
      // "UGF+4th+Terrace",
      // "UGF+TF",
      // "UGF+TF+Terrace",
      // "UGF+TF+4th",
      // "UGF+TF+4th+Terrace",
      // "UGF+SF",
      // "UGF+SF+Terrace",
      // "UGF+SF+4th",
      // "UGF+SF+4th+Terrace",
      // "UGF+SF+TF",
      // "UGF+SF+TF+Terrace",
      // "UGF+SF+TF+4th",
      // "UGF+SF+TF+4th+Terrace",
      // "UGF+FF",
      // "UGF+FF+Terrace",
      // "UGF+FF+4th",
      // "UGF+FF+4th+Terrace",
      // "UGF+FF+TF",
      // "UGF+FF+TF+Terrace",
      // "UGF+FF+TF+4th",
      // "UGF+FF+TF+4th+Terrace",
      // "UGF+FF+SF",
      // "UGF+FF+SF+Terrace",
      // "UGF+FF+SF+4th",
      // "UGF+FF+SF+4th+Terrace",
      // "UGF+FF+SF+TF",
      // "UGF+FF+SF+TF+Terrace",
      // "UGF+FF+SF+TF+4th",
      // "UGF+FF+SF+TF+4th+Terrace",
      // "BMT",
      // "BMT+Terrace",
      // "BMT+4th",
      // "BMT+4th+Terrace",
      // "BMT+TF",
      // "BMT+TF+Terrace",
      // "BMT+TF+4th",
      // "BMT+TF+4th+Terrace",
      // "BMT+SF",
      // "BMT+SF+Terrace",
      // "BMT+SF+4th",
      // "BMT+SF+4th+Terrace",
      // "BMT+SF+TF",
      // "BMT+SF+TF+Terrace",
      // "BMT+SF+TF+4th",
      // "BMT+SF+TF+4th+Terrace",
      // "BMT+FF",
      // "BMT+FF+Terrace",
      // "BMT+FF+4th",
      // "BMT+FF+4th+Terrace",
      // "BMT+FF+TF",
      // "BMT+FF+TF+Terrace",
      // "BMT+FF+TF+4th",
      // "BMT+FF+TF+4th+Terrace",
      // "BMT+FF+SF",
      // "BMT+FF+SF+Terrace",
      // "BMT+FF+SF+4th",
      // "BMT+FF+SF+4th+Terrace",
      // "BMT+FF+SF+TF",
      // "BMT+FF+SF+TF+Terrace",
      // "BMT+FF+SF+TF+4th",
      // "BMT+FF+SF+TF+4th+Terrace",
      // "BMT+UGF",
      // "BMT+UGF+Terrace",
      // "BMT+UGF+4th",
      // "BMT+UGF+4th+Terrace",
      // "BMT+UGF+TF",
      // "BMT+UGF+TF+Terrace",
      // "BMT+UGF+TF+4th",
      // "BMT+UGF+TF+4th+Terrace",
      // "BMT+UGF+SF",
      // "BMT+UGF+SF+Terrace",
      // "BMT+UGF+SF+4th",
      // "BMT+UGF+SF+4th+Terrace",
      // "BMT+UGF+SF+TF",
      // "BMT+UGF+SF+TF+Terrace",
      // "BMT+UGF+SF+TF+4th",
      // "BMT+UGF+SF+TF+4th+Terrace",
      // "BMT+UGF+FF",
      // "BMT+UGF+FF+Terrace",
      // "BMT+UGF+FF+4th",
      // "BMT+UGF+FF+4th+Terrace",
      // "BMT+UGF+FF+TF",
      // "BMT+UGF+FF+TF+Terrace",
      // "BMT+UGF+FF+TF+4th",
      // "BMT+UGF+FF+TF+4th+Terrace",
      // "BMT+UGF+FF+SF",
      // "BMT+UGF+FF+SF+Terrace",
      // "BMT+UGF+FF+SF+4th",
      // "BMT+UGF+FF+SF+4th+Terrace",
      // "BMT+UGF+FF+SF+TF",
      // "BMT+UGF+FF+SF+TF+Terrace",
      // "BMT+UGF+FF+SF+TF+4th",
      // "BMT+UGF+FF+SF+TF+4th+Terrace",
      // "Stilt",
      // "Stilt+Terrace",
      // "Stilt+4th",
      // "Stilt+4th+Terrace",
      // "Stilt+TF",
      // "Stilt+TF+Terrace",
      // "Stilt+TF+4th",
      // "Stilt+TF+4th+Terrace",
      // "Stilt+SF",
      // "Stilt+SF+Terrace",
      // "Stilt+SF+4th",
      // "Stilt+SF+4th+Terrace",
      // "Stilt+SF+TF",
      // "Stilt+SF+TF+Terrace",
      // "Stilt+SF+TF+4th",
      // "Stilt+SF+TF+4th+Terrace",
      // "Stilt+FF",
      // "Stilt+FF+Terrace",
      // "Stilt+FF+4th",
      // "Stilt+FF+4th+Terrace",
      // "Stilt+FF+TF",
      // "Stilt+FF+TF+Terrace",
      // "Stilt+FF+TF+4th",
      // "Stilt+FF+TF+4th+Terrace",
      // "Stilt+FF+SF",
      // "Stilt+FF+SF+Terrace",
      // "Stilt+FF+SF+4th",
      // "Stilt+FF+SF+4th+Terrace",
      // "Stilt+FF+SF+TF",
      // "Stilt+FF+SF+TF+Terrace",
      // "Stilt+FF+SF+TF+4th",
      // "Stilt+FF+SF+TF+4th+Terrace",
      // "Stilt+UGF",
      // "Stilt+UGF+Terrace",
      // "Stilt+UGF+4th",
      // "Stilt+UGF+4th+Terrace",
      // "Stilt+UGF+TF",
      // "Stilt+UGF+TF+Terrace",
      // "Stilt+UGF+TF+4th",
      // "Stilt+UGF+TF+4th+Terrace",
      // "Stilt+UGF+SF",
      // "Stilt+UGF+SF+Terrace",
      // "Stilt+UGF+SF+4th",
      // "Stilt+UGF+SF+4th+Terrace",
      // "Stilt+UGF+SF+TF",
      // "Stilt+UGF+SF+TF+Terrace",
      // "Stilt+UGF+SF+TF+4th",
      // "Stilt+UGF+SF+TF+4th+Terrace",
      // "Stilt+UGF+FF",
      // "Stilt+UGF+FF+Terrace",
      // "Stilt+UGF+FF+4th",
      // "Stilt+UGF+FF+4th+Terrace",
      // "Stilt+UGF+FF+TF",
      // "Stilt+UGF+FF+TF+Terrace",
      // "Stilt+UGF+FF+TF+4th",
      // "Stilt+UGF+FF+TF+4th+Terrace",
      // "Stilt+UGF+FF+SF",
      // "Stilt+UGF+FF+SF+Terrace",
      // "Stilt+UGF+FF+SF+4th",
      // "Stilt+UGF+FF+SF+4th+Terrace",
      // "Stilt+UGF+FF+SF+TF",
      // "Stilt+UGF+FF+SF+TF+Terrace",
      // "Stilt+UGF+FF+SF+TF+4th",
      // "Stilt+UGF+FF+SF+TF+4th+Terrace",
      // "Stilt+BMT",
      // "Stilt+BMT+Terrace",
      // "Stilt+BMT+4th",
      // "Stilt+BMT+4th+Terrace",
      // "Stilt+BMT+TF",
      // "Stilt+BMT+TF+Terrace",
      // "Stilt+BMT+TF+4th",
      // "Stilt+BMT+TF+4th+Terrace",
      // "Stilt+BMT+SF",
      // "Stilt+BMT+SF+Terrace",
      // "Stilt+BMT+SF+4th",
      // "Stilt+BMT+SF+4th+Terrace",
      // "Stilt+BMT+SF+TF",
      // "Stilt+BMT+SF+TF+Terrace",
      // "Stilt+BMT+SF+TF+4th",
      // "Stilt+BMT+SF+TF+4th+Terrace",
      // "Stilt+BMT+FF",
      // "Stilt+BMT+FF+Terrace",
      // "Stilt+BMT+FF+4th",
      // "Stilt+BMT+FF+4th+Terrace",
      // "Stilt+BMT+FF+TF",
      // "Stilt+BMT+FF+TF+Terrace",
      // "Stilt+BMT+FF+TF+4th",
      // "Stilt+BMT+FF+TF+4th+Terrace",
      // "Stilt+BMT+FF+SF",
      // "Stilt+BMT+FF+SF+Terrace",
      // "Stilt+BMT+FF+SF+4th",
      // "Stilt+BMT+FF+SF+4th+Terrace",
      // "Stilt+BMT+FF+SF+TF",
      // "Stilt+BMT+FF+SF+TF+Terrace",
      // "Stilt+BMT+FF+SF+TF+4th",
      // "Stilt+BMT+FF+SF+TF+4th+Terrace",
      // "Stilt+BMT+UGF",
      // "Stilt+BMT+UGF+Terrace",
      // "Stilt+BMT+UGF+4th",
      // "Stilt+BMT+UGF+4th+Terrace",
      // "Stilt+BMT+UGF+TF",
      // "Stilt+BMT+UGF+TF+Terrace",
      // "Stilt+BMT+UGF+TF+4th",
      // "Stilt+BMT+UGF+TF+4th+Terrace",
      // "Stilt+BMT+UGF+SF",
      // "Stilt+BMT+UGF+SF+Terrace",
      // "Stilt+BMT+UGF+SF+4th",
      // "Stilt+BMT+UGF+SF+4th+Terrace",
      // "Stilt+BMT+UGF+SF+TF",
      // "Stilt+BMT+UGF+SF+TF+Terrace",
      // "Stilt+BMT+UGF+SF+TF+4th",
      // "Stilt+BMT+UGF+SF+TF+4th+Terrace",
      // "Stilt+BMT+UGF+FF",
      // "Stilt+BMT+UGF+FF+Terrace",
      // "Stilt+BMT+UGF+FF+4th",
      // "Stilt+BMT+UGF+FF+4th+Terrace",
      // "Stilt+BMT+UGF+FF+TF",
      // "Stilt+BMT+UGF+FF+TF+Terrace",
      // "Stilt+BMT+UGF+FF+TF+4th",
      // "Stilt+BMT+UGF+FF+TF+4th+Terrace",
      // "Stilt+BMT+UGF+FF+SF",
      // "Stilt+BMT+UGF+FF+SF+Terrace",
      // "Stilt+BMT+UGF+FF+SF+4th",
      // "Stilt+BMT+UGF+FF+SF+4th+Terrace",
      // "Stilt+BMT+UGF+FF+SF+TF",
      // "Stilt+BMT+UGF+FF+SF+TF+Terrace",
      // "Stilt+BMT+UGF+FF+SF+TF+4th",
      // "Stilt+BMT+UGF+FF+SF+TF+4th+Terrace",
    ],
  };
  return data;
};
